import { useState } from "react";
import { send_pin_code_api } from "../../DAL/Users";
import { useSnackbar } from "notistack";
import { Icon } from "@iconify/react";
import SubmitButton from "../GeneralComponents/SubmitButton";

export default function SendPinCode(props) {
  const {
    formData,
    setFormData,
    setErrors,
    errors,
    setFormState,
    handleLogin,
  } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    const postData = { email: formData.email };
    const result = await send_pin_code_api(postData);
    if (result.code === 200) {
      setFormState(1);
    } else {
      enqueueSnackbar(`${result.message}`, { variant: "error" });
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <div className="input-wrapper">
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            className={errors.email ? "has-error" : ""}
            autoComplete="email"
            autoFocus
          />
        </div>
        {errors.email && (
          <span className="error-message">
            <Icon icon="mdi:alert-circle" className="error-icon" />
            {errors.email}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <SubmitButton
          isLoading={isLoading}
          btnText="Send OTP"
          loadingText="Sending..."
        />
        <button
          type="button"
          onClick={handleLogin}
          className="btn-secondary"
        >
          <Icon icon="mdi:arrow-left" className="btn-icon" />
          Back to Login
        </button>
      </div>
    </form>
  );
}
